import { render, staticRenderFns } from "./category-banners-slot.vue?vue&type=template&id=376f6b30&"
import script from "./category-banners-slot.vue?vue&type=script&lang=js&"
export * from "./category-banners-slot.vue?vue&type=script&lang=js&"
import style0 from "./category-banners-slot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376f6b30')) {
      api.createRecord('376f6b30', component.options)
    } else {
      api.reload('376f6b30', component.options)
    }
    module.hot.accept("./category-banners-slot.vue?vue&type=template&id=376f6b30&", function () {
      api.rerender('376f6b30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/category-banners-slot/category-banners-slot.vue"
export default component.exports